
import React from 'react';
import { motion } from 'framer-motion';
import SupportTabs from '../components/SupportTabs';

const noticeData = [
    { id: 1, title: '2025년 설 연휴 휴무 안내', date: '2025-01-20', writer: '관리자', views: 105 },
    { id: 2, title: '홈페이지 리뉴얼 오픈 이벤트', date: '2024-12-15', writer: '관리자', views: 532 },
    { id: 3, title: '시스템 점검 안내 (10/24)', date: '2024-10-20', writer: '운영팀', views: 89 },
    { id: 4, title: '2024년 상반기 우수 사원 표창', date: '2024-07-05', writer: '인사팀', views: 240 },
    { id: 5, title: '신제품 출시 기념 할인 프로모션', date: '2024-05-01', writer: '마케팅', views: 1200 },
];

function Notice() {
    return (
        <div className="text-gray-800">
            {/* Hero Section */}
            <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
                <div className="absolute inset-0 bg-black bg-opacity-50" />
                <div className="relative z-10 text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white">고객지원</h1>
                    <p className="mt-4 text-white text-lg md:text-xl">
                        고객님의 궁금한 점을 해결해 드립니다.
                    </p>
                </div>
                {/* Support Tabs */}
                <SupportTabs />
            </section>

            {/* Bulletin Board Section */}
            <section className="py-16 px-6 md:px-20 max-w-6xl mx-auto">
                <div className="flex justify-between items-end mb-4 border-b pb-4 border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-800">공지사항</h2>
                    <span className="text-sm text-gray-500">총 {noticeData.length}건</span>
                </div>

                {/* Table / List */}
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-100 text-gray-700 border-b border-gray-300">
                                <th className="p-4 w-16 text-center font-semibold">No.</th>
                                <th className="p-4 font-semibold">제목</th>
                                <th className="p-4 w-32 text-center font-semibold">작성자</th>
                                <th className="p-4 w-32 text-center font-semibold">작성일</th>
                                <th className="p-4 w-24 text-center font-semibold">조회수</th>
                            </tr>
                        </thead>
                        <tbody>
                            {noticeData.map((item, index) => (
                                <motion.tr
                                    key={item.id}
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                    className="border-b border-gray-200 hover:bg-gray-50 transition-colors"
                                >
                                    <td className="p-4 text-center text-gray-500">{noticeData.length - index}</td>
                                    <td className="p-4 font-medium text-gray-800 cursor-pointer hover:underline">{item.title}</td>
                                    <td className="p-4 text-center text-gray-600">{item.writer}</td>
                                    <td className="p-4 text-center text-gray-500">{item.date}</td>
                                    <td className="p-4 text-center text-gray-500">{item.views}</td>
                                </motion.tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

export default Notice;
